import { Box } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import type { FC } from "react";
import { Outlet, useOutletContext } from "react-router-dom";
import { theme2 } from "../../theme";

/** Renders the reports section with the brand theme on a grey canvas. */
const StatisticsLayout: FC = () => {
  const parentContext = useOutletContext();
  return (
    <ThemeProvider theme={theme2}>
      <Box sx={{ bgcolor: "background.default", borderRadius: 2, p: { xs: 2, md: 4 }, mt: 1 }}>
        <Outlet context={parentContext} />
      </Box>
    </ThemeProvider>
  );
};

export default StatisticsLayout;
